/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52458.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class SubscriptionApi extends runtime.BaseAPI {
    /**
     */
    async acceptQuoteRaw(requestParameters, initOverrides) {
        if (requestParameters.quoteId === null || requestParameters.quoteId === undefined) {
            throw new runtime.RequiredError('quoteId', 'Required parameter requestParameters.quoteId was null or undefined when calling acceptQuote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote/{quoteId}/accept`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters.quoteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async acceptQuote(requestParameters, initOverrides) {
        const response = await this.acceptQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async appendProductAddonPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.addon === null || requestParameters.addon === undefined) {
            throw new runtime.RequiredError('addon', 'Required parameter requestParameters.addon was null or undefined when calling appendProductAddonPlan.');
        }
        if (requestParameters.addPlanOptions === null || requestParameters.addPlanOptions === undefined) {
            throw new runtime.RequiredError('addPlanOptions', 'Required parameter requestParameters.addPlanOptions was null or undefined when calling appendProductAddonPlan.');
        }
        const queryParameters = {};
        if (requestParameters.addon !== undefined) {
            queryParameters['addon'] = requestParameters.addon;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/addon`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addPlanOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async appendProductAddonPlan(requestParameters, initOverrides) {
        const response = await this.appendProductAddonPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async appendProductPhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters.addPhoneNumberOptions === null || requestParameters.addPhoneNumberOptions === undefined) {
            throw new runtime.RequiredError('addPhoneNumberOptions', 'Required parameter requestParameters.addPhoneNumberOptions was null or undefined when calling appendProductPhoneNumber.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/phone-number`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addPhoneNumberOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async appendProductPhoneNumber(requestParameters, initOverrides) {
        const response = await this.appendProductPhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async appendProductPhonePlanRaw(requestParameters, initOverrides) {
        if (requestParameters.addPhonePlanOptions === null || requestParameters.addPhonePlanOptions === undefined) {
            throw new runtime.RequiredError('addPhonePlanOptions', 'Required parameter requestParameters.addPhonePlanOptions was null or undefined when calling appendProductPhonePlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/phone-plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addPhonePlanOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async appendProductPhonePlan(requestParameters, initOverrides) {
        const response = await this.appendProductPhonePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async appendProductUserPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.addUserPlanOptions === null || requestParameters.addUserPlanOptions === undefined) {
            throw new runtime.RequiredError('addUserPlanOptions', 'Required parameter requestParameters.addUserPlanOptions was null or undefined when calling appendProductUserPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/user-plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addUserPlanOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async appendProductUserPlan(requestParameters, initOverrides) {
        const response = await this.appendProductUserPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async canUseFeatureRaw(requestParameters, initOverrides) {
        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit', 'Required parameter requestParameters.limit was null or undefined when calling canUseFeature.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/can/limit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async canUseFeature(requestParameters, initOverrides) {
        await this.canUseFeatureRaw(requestParameters, initOverrides);
    }
    /**
     */
    async canUseFeature1Raw(requestParameters, initOverrides) {
        if (requestParameters.feature === null || requestParameters.feature === undefined) {
            throw new runtime.RequiredError('feature', 'Required parameter requestParameters.feature was null or undefined when calling canUseFeature1.');
        }
        const queryParameters = {};
        if (requestParameters.feature !== undefined) {
            queryParameters['feature'] = requestParameters.feature;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/can/feature`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async canUseFeature1(requestParameters, initOverrides) {
        await this.canUseFeature1Raw(requestParameters, initOverrides);
    }
    /**
     */
    async cancelQuoteRaw(requestParameters, initOverrides) {
        if (requestParameters.quoteId === null || requestParameters.quoteId === undefined) {
            throw new runtime.RequiredError('quoteId', 'Required parameter requestParameters.quoteId was null or undefined when calling cancelQuote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote/{quoteId}/cancel`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters.quoteId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async cancelQuote(requestParameters, initOverrides) {
        const response = await this.cancelQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createAppendSessionRaw(requestParameters, initOverrides) {
        if (requestParameters.createAppendSession === null || requestParameters.createAppendSession === undefined) {
            throw new runtime.RequiredError('createAppendSession', 'Required parameter requestParameters.createAppendSession was null or undefined when calling createAppendSession.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/append-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createAppendSession,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createAppendSession(requestParameters, initOverrides) {
        const response = await this.createAppendSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createBillingPortalSessionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/billing-portal-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createBillingPortalSession(initOverrides) {
        const response = await this.createBillingPortalSessionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async createUpgradeSessionRaw(requestParameters, initOverrides) {
        if (requestParameters.createUpgradeSession === null || requestParameters.createUpgradeSession === undefined) {
            throw new runtime.RequiredError('createUpgradeSession', 'Required parameter requestParameters.createUpgradeSession was null or undefined when calling createUpgradeSession.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/create-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUpgradeSession,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createUpgradeSession(requestParameters, initOverrides) {
        const response = await this.createUpgradeSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createUpgradeSessionAddMissingExtrasRaw(requestParameters, initOverrides) {
        if (requestParameters.createUpgradeSessionAddMissingExtras === null || requestParameters.createUpgradeSessionAddMissingExtras === undefined) {
            throw new runtime.RequiredError('createUpgradeSessionAddMissingExtras', 'Required parameter requestParameters.createUpgradeSessionAddMissingExtras was null or undefined when calling createUpgradeSessionAddMissingExtras.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/create-session-add-missing-extras`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUpgradeSessionAddMissingExtras,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createUpgradeSessionAddMissingExtras(requestParameters, initOverrides) {
        const response = await this.createUpgradeSessionAddMissingExtrasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createUpgradeSessionWithExtrasRaw(requestParameters, initOverrides) {
        if (requestParameters.createUpgradeSessionWithExtras === null || requestParameters.createUpgradeSessionWithExtras === undefined) {
            throw new runtime.RequiredError('createUpgradeSessionWithExtras', 'Required parameter requestParameters.createUpgradeSessionWithExtras was null or undefined when calling createUpgradeSessionWithExtras.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/create-session-with-extras`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUpgradeSessionWithExtras,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createUpgradeSessionWithExtras(requestParameters, initOverrides) {
        const response = await this.createUpgradeSessionWithExtrasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createUpgradeSessionWithSuggestedPlanForExtrasRaw(requestParameters, initOverrides) {
        if (requestParameters.createUpgradeSessionWithSuggestedPlanForExtras === null || requestParameters.createUpgradeSessionWithSuggestedPlanForExtras === undefined) {
            throw new runtime.RequiredError('createUpgradeSessionWithSuggestedPlanForExtras', 'Required parameter requestParameters.createUpgradeSessionWithSuggestedPlanForExtras was null or undefined when calling createUpgradeSessionWithSuggestedPlanForExtras.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/create-session-with-suggested-plan-for-extras`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUpgradeSessionWithSuggestedPlanForExtras,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createUpgradeSessionWithSuggestedPlanForExtras(requestParameters, initOverrides) {
        const response = await this.createUpgradeSessionWithSuggestedPlanForExtrasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAIPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteAIPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/ai-plans/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAIPlan(requestParameters, initOverrides) {
        const response = await this.deleteAIPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAIPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/ai-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAIPlans(initOverrides) {
        const response = await this.deleteAIPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteConnectorPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteConnectorPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/connector-plans/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteConnectorPlan(requestParameters, initOverrides) {
        const response = await this.deleteConnectorPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteConnectorPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/connector-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteConnectorPlans(initOverrides) {
        const response = await this.deleteConnectorPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteCustomerRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/delete-customer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSubscriptionEndedOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteCustomer(requestParameters = {}, initOverrides) {
        await this.deleteCustomerRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteEmailPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/email-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteEmailPlans(initOverrides) {
        const response = await this.deleteEmailPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteGuestPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteGuestPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/guest-plans/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGuestPlan(requestParameters, initOverrides) {
        const response = await this.deleteGuestPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteGuestPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/guest-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGuestPlans(initOverrides) {
        const response = await this.deleteGuestPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteInboxPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteInboxPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/inbox-plans/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteInboxPlan(requestParameters, initOverrides) {
        const response = await this.deleteInboxPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteInboxPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/inbox-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteInboxPlans(initOverrides) {
        const response = await this.deleteInboxPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deletePhonePlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/phone-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deletePhonePlans(initOverrides) {
        const response = await this.deletePhonePlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteProductValidationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/product-validation`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteProductValidation(initOverrides) {
        const response = await this.deleteProductValidationRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteUserPlanRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteUserPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/user-plans/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteUserPlan(requestParameters, initOverrides) {
        const response = await this.deleteUserPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteUserPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/user-plans`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteUserPlans(initOverrides) {
        const response = await this.deleteUserPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async downloadQuoteRaw(requestParameters, initOverrides) {
        if (requestParameters.quoteId === null || requestParameters.quoteId === undefined) {
            throw new runtime.RequiredError('quoteId', 'Required parameter requestParameters.quoteId was null or undefined when calling downloadQuote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote/{quoteId}/bytes`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters.quoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async downloadQuote(requestParameters, initOverrides) {
        await this.downloadQuoteRaw(requestParameters, initOverrides);
    }
    /**
     */
    async endSubscriptionImmediatelyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/end-subscription-immediately`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSubscriptionEndedOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async endSubscriptionImmediately(requestParameters = {}, initOverrides) {
        await this.endSubscriptionImmediatelyRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getAIPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/ai-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAIPlans(initOverrides) {
        const response = await this.getAIPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getAddonSupportRaw(requestParameters, initOverrides) {
        if (requestParameters.subscriptionType === null || requestParameters.subscriptionType === undefined) {
            throw new runtime.RequiredError('subscriptionType', 'Required parameter requestParameters.subscriptionType was null or undefined when calling getAddonSupport.');
        }
        const queryParameters = {};
        if (requestParameters.subscriptionType !== undefined) {
            queryParameters['subscriptionType'] = requestParameters.subscriptionType;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/addon-support`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAddonSupport(requestParameters, initOverrides) {
        const response = await this.getAddonSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getAllQuotesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getAllQuotes(initOverrides) {
        const response = await this.getAllQuotesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getConnectorPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/connector-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getConnectorPlans(initOverrides) {
        const response = await this.getConnectorPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmailPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/email-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmailPlans(initOverrides) {
        const response = await this.getEmailPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmailValidationSubscriptionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/email-validation-subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmailValidationSubscription(initOverrides) {
        const response = await this.getEmailValidationSubscriptionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEmailValidationSubscriptionOptionalRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/email-validation-subscription-optional`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEmailValidationSubscriptionOptional(initOverrides) {
        const response = await this.getEmailValidationSubscriptionOptionalRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getEventCountsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/event-counts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getEventCounts(initOverrides) {
        const response = await this.getEventCountsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getFullNotificationMarkReadRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getFullNotificationMarkRead.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/notifications/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getFullNotificationMarkRead(requestParameters, initOverrides) {
        const response = await this.getFullNotificationMarkReadRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getGuestPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/guest-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getGuestPlans(initOverrides) {
        const response = await this.getGuestPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getInboxPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/inbox-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getInboxPlans(initOverrides) {
        const response = await this.getInboxPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getMonthlyUsageChartsRaw(requestParameters, initOverrides) {
        if (requestParameters.month === null || requestParameters.month === undefined) {
            throw new runtime.RequiredError('month', 'Required parameter requestParameters.month was null or undefined when calling getMonthlyUsageCharts.');
        }
        if (requestParameters.year === null || requestParameters.year === undefined) {
            throw new runtime.RequiredError('year', 'Required parameter requestParameters.year was null or undefined when calling getMonthlyUsageCharts.');
        }
        const queryParameters = {};
        if (requestParameters.month !== undefined) {
            queryParameters['month'] = requestParameters.month;
        }
        if (requestParameters.year !== undefined) {
            queryParameters['year'] = requestParameters.year;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/monthly-usage-charts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getMonthlyUsageCharts(requestParameters, initOverrides) {
        const response = await this.getMonthlyUsageChartsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get notification HTML content
     */
    async getNotificationHTMLContentRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getNotificationHTMLContent.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/notifications/{id}/html`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get notification HTML content
     */
    async getNotificationHTMLContent(requestParameters, initOverrides) {
        const response = await this.getNotificationHTMLContentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getNotificationsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getNotifications(initOverrides) {
        const response = await this.getNotificationsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getOpenQuotesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote/open`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getOpenQuotes(initOverrides) {
        const response = await this.getOpenQuotesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getPaymentFailuresRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/payment-failures`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPaymentFailures(initOverrides) {
        const response = await this.getPaymentFailuresRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getPhonePlansAvailabilityOptionsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/phone-plans/availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPhonePlansAvailabilityOptions(initOverrides) {
        const response = await this.getPhonePlansAvailabilityOptionsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getPhonePlansListRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/phone-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPhonePlansList(initOverrides) {
        const response = await this.getPhonePlansListRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        if (requestParameters.subscriptionSchedule !== undefined) {
            queryParameters['subscriptionSchedule'] = requestParameters.subscriptionSchedule;
        }
        if (requestParameters.planCurrency !== undefined) {
            queryParameters['planCurrency'] = requestParameters.planCurrency;
        }
        if (requestParameters.desiresAddonPlan !== undefined) {
            queryParameters['desiresAddonPlan'] = requestParameters.desiresAddonPlan;
        }
        if (requestParameters.desiresUserPlan !== undefined) {
            queryParameters['desiresUserPlan'] = requestParameters.desiresUserPlan;
        }
        if (requestParameters.desiresPhonePlan !== undefined) {
            queryParameters['desiresPhonePlan'] = requestParameters.desiresPhonePlan;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/plans-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getPlanSupportRaw(requestParameters, initOverrides) {
        if (requestParameters.addon === null || requestParameters.addon === undefined) {
            throw new runtime.RequiredError('addon', 'Required parameter requestParameters.addon was null or undefined when calling getPlanSupport.');
        }
        const queryParameters = {};
        if (requestParameters.addon !== undefined) {
            queryParameters['addon'] = requestParameters.addon;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/plan-support`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPlanSupport(requestParameters, initOverrides) {
        const response = await this.getPlanSupportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getPlans(initOverrides) {
        const response = await this.getPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductAIPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-ai-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductAIPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductAIPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductConnectorPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-connector-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductConnectorPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductConnectorPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductEmailPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-email-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductEmailPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductEmailPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductEmailValidationDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-email-validation-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductEmailValidationDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductEmailValidationDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductGuestPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-guest-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductGuestPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductGuestPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductInboxPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-inbox-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductInboxPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductInboxPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductPhoneNumberDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-phone-number-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductPhoneNumberDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductPhoneNumberDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductPhonePlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-phone-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductPhonePlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductPhonePlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getProductUserPlanDisplaysRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.countryCode !== undefined) {
            queryParameters['countryCode'] = requestParameters.countryCode;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/product-user-plan-displays`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProductUserPlanDisplays(requestParameters = {}, initOverrides) {
        const response = await this.getProductUserPlanDisplaysRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getQuoteRaw(requestParameters, initOverrides) {
        if (requestParameters.quoteId === null || requestParameters.quoteId === undefined) {
            throw new runtime.RequiredError('quoteId', 'Required parameter requestParameters.quoteId was null or undefined when calling getQuote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote/{quoteId}`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters.quoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getQuote(requestParameters, initOverrides) {
        const response = await this.getQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getQuoteInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.quoteId === null || requestParameters.quoteId === undefined) {
            throw new runtime.RequiredError('quoteId', 'Required parameter requestParameters.quoteId was null or undefined when calling getQuoteInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote/{quoteId}/invoice`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters.quoteId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getQuoteInvoice(requestParameters, initOverrides) {
        const response = await this.getQuoteInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getQuoteParamsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/quote-params`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getQuoteParams(initOverrides) {
        const response = await this.getQuoteParamsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getStatisticsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getStatistics(initOverrides) {
        const response = await this.getStatisticsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getStatisticsFractionRaw(requestParameters, initOverrides) {
        if (requestParameters.fractionType === null || requestParameters.fractionType === undefined) {
            throw new runtime.RequiredError('fractionType', 'Required parameter requestParameters.fractionType was null or undefined when calling getStatisticsFraction.');
        }
        const queryParameters = {};
        if (requestParameters.fractionType !== undefined) {
            queryParameters['fractionType'] = requestParameters.fractionType;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/stats/fraction`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getStatisticsFraction(requestParameters, initOverrides) {
        const response = await this.getStatisticsFractionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getStatsConstantsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/stats-constants`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getStatsConstants(initOverrides) {
        const response = await this.getStatsConstantsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getSubscriptionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getSubscription(initOverrides) {
        const response = await this.getSubscriptionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getSubscriptionOptionalRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/optional`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getSubscriptionOptional(initOverrides) {
        const response = await this.getSubscriptionOptionalRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsagePhoneNumberRaw(requestParameters, initOverrides) {
        if (requestParameters.phoneNumberId === null || requestParameters.phoneNumberId === undefined) {
            throw new runtime.RequiredError('phoneNumberId', 'Required parameter requestParameters.phoneNumberId was null or undefined when calling getUsagePhoneNumber.');
        }
        const queryParameters = {};
        if (requestParameters.phoneNumberId !== undefined) {
            queryParameters['phoneNumberId'] = requestParameters.phoneNumberId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/usage-summary/phone-number`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsagePhoneNumber(requestParameters, initOverrides) {
        const response = await this.getUsagePhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageRecordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/usage-records`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageRecords(requestParameters = {}, initOverrides) {
        const response = await this.getUsageRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUsageSummaryRaw(requestParameters, initOverrides) {
        if (requestParameters.addon === null || requestParameters.addon === undefined) {
            throw new runtime.RequiredError('addon', 'Required parameter requestParameters.addon was null or undefined when calling getUsageSummary.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/usage-summary/{addon}`.replace(`{${"addon"}}`, encodeURIComponent(String(requestParameters.addon))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUsageSummary(requestParameters, initOverrides) {
        const response = await this.getUsageSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserAddonsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/addons`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserAddons(initOverrides) {
        const response = await this.getUserAddonsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserLimitsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/user-limits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserLimits(initOverrides) {
        const response = await this.getUserLimitsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getUserPlansRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/user-plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getUserPlans(initOverrides) {
        const response = await this.getUserPlansRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async handleStripeWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling handleStripeWebhook.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/webhooks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async handleStripeWebhook(requestParameters, initOverrides) {
        const response = await this.handleStripeWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async markNotificationsSeenRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/notifications`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async markNotificationsSeen(initOverrides) {
        const response = await this.markNotificationsSeenRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async putSpankNotificationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.message !== undefined) {
            queryParameters['message'] = requestParameters.message;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/notifications/spank`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async putSpankNotification(requestParameters = {}, initOverrides) {
        const response = await this.putSpankNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async refreshSubscriptionStatusRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async refreshSubscriptionStatus(initOverrides) {
        const response = await this.refreshSubscriptionStatusRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async submitUserFeedbackRaw(requestParameters, initOverrides) {
        if (requestParameters.createUserFeedbackSubmissionOptions === null || requestParameters.createUserFeedbackSubmissionOptions === undefined) {
            throw new runtime.RequiredError('createUserFeedbackSubmissionOptions', 'Required parameter requestParameters.createUserFeedbackSubmissionOptions was null or undefined when calling submitUserFeedback.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/submit-user-feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createUserFeedbackSubmissionOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async submitUserFeedback(requestParameters, initOverrides) {
        await this.submitUserFeedbackRaw(requestParameters, initOverrides);
    }
    /**
     */
    async waitForPhoneCountRaw(requestParameters, initOverrides) {
        if (requestParameters.count === null || requestParameters.count === undefined) {
            throw new runtime.RequiredError('count', 'Required parameter requestParameters.count was null or undefined when calling waitForPhoneCount.');
        }
        if (requestParameters.timeout === null || requestParameters.timeout === undefined) {
            throw new runtime.RequiredError('timeout', 'Required parameter requestParameters.timeout was null or undefined when calling waitForPhoneCount.');
        }
        const queryParameters = {};
        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }
        if (requestParameters.timeout !== undefined) {
            queryParameters['timeout'] = requestParameters.timeout;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/wait-for-phone-count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async waitForPhoneCount(requestParameters, initOverrides) {
        await this.waitForPhoneCountRaw(requestParameters, initOverrides);
    }
    /**
     */
    async waitForRefreshSessionUpgradeRaw(requestParameters, initOverrides) {
        if (requestParameters.timeout === null || requestParameters.timeout === undefined) {
            throw new runtime.RequiredError('timeout', 'Required parameter requestParameters.timeout was null or undefined when calling waitForRefreshSessionUpgrade.');
        }
        const queryParameters = {};
        if (requestParameters.timeout !== undefined) {
            queryParameters['timeout'] = requestParameters.timeout;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/wait-for-refresh-session-upgrade`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async waitForRefreshSessionUpgrade(requestParameters, initOverrides) {
        const response = await this.waitForRefreshSessionUpgradeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async waitForStripeWebhookRaw(requestParameters, initOverrides) {
        if (requestParameters.timeout === null || requestParameters.timeout === undefined) {
            throw new runtime.RequiredError('timeout', 'Required parameter requestParameters.timeout was null or undefined when calling waitForStripeWebhook.');
        }
        if (requestParameters.eventType === null || requestParameters.eventType === undefined) {
            throw new runtime.RequiredError('eventType', 'Required parameter requestParameters.eventType was null or undefined when calling waitForStripeWebhook.');
        }
        const queryParameters = {};
        if (requestParameters.timeout !== undefined) {
            queryParameters['timeout'] = requestParameters.timeout;
        }
        if (requestParameters.eventType !== undefined) {
            queryParameters['eventType'] = requestParameters.eventType;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/upgrade/wait-for-stripe-webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async waitForStripeWebhook(requestParameters, initOverrides) {
        await this.waitForStripeWebhookRaw(requestParameters, initOverrides);
    }
    /**
     */
    async whiteListEmailAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.whiteListOptions === null || requestParameters.whiteListOptions === undefined) {
            throw new runtime.RequiredError('whiteListOptions', 'Required parameter requestParameters.whiteListOptions was null or undefined when calling whiteListEmailAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/subscription/whitelist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.whiteListOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async whiteListEmailAddress(requestParameters, initOverrides) {
        const response = await this.whiteListEmailAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AppendProductAddonPlanAddonEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const CanUseFeatureLimitEnum = {
    CreateInbox: 'CreateInbox',
    GetMailServerRecords: 'GetMailServerRecords',
    ReceiveEmail: 'ReceiveEmail',
    SendEmail: 'SendEmail',
    VerifyEmailAddress: 'VerifyEmailAddress',
    CreateOrganization: 'CreateOrganization',
    CreateDomain: 'CreateDomain',
    CreateAlias: 'CreateAlias',
    Threaded: 'Threaded',
    ManageOrganization: 'ManageOrganization',
    AddOrganizationUser: 'AddOrganizationUser'
};
/**
 * @export
 */
export const CanUseFeature1FeatureEnum = {
    BulkCreate: 'BulkCreate',
    BulkSend: 'BulkSend',
    BulkDelete: 'BulkDelete',
    Contacts: 'Contacts',
    PermanentInboxes: 'PermanentInboxes',
    UserPassword: 'UserPassword',
    Webhooks: 'Webhooks',
    InboxRulesets: 'InboxRulesets',
    Attachments: 'Attachments',
    Zapier: 'Zapier',
    TrackingPixels: 'TrackingPixels',
    InboxForwarders: 'InboxForwarders',
    InboxRepliers: 'InboxRepliers',
    TeamInbox: 'TeamInbox',
    SamlSSO: 'SamlSSO',
    EmailValidation: 'EmailValidation',
    SendWithQueue: 'SendWithQueue',
    Connectors: 'Connectors',
    AI: 'AI',
    GuestPortals: 'GuestPortals',
    EmailFeatureCheck: 'EmailFeatureCheck',
    Backups: 'Backups',
    Screenshots: 'Screenshots'
};
/**
 * @export
 */
export const GetAddonSupportSubscriptionTypeEnum = {
    PRO_MONTHLY: 'PRO_MONTHLY',
    STARTER: 'STARTER',
    PRO: 'PRO',
    TEAM: 'TEAM',
    ENTERPRISE: 'ENTERPRISE'
};
/**
 * @export
 */
export const GetMonthlyUsageChartsMonthEnum = {
    JANUARY: 'JANUARY',
    FEBRUARY: 'FEBRUARY',
    MARCH: 'MARCH',
    APRIL: 'APRIL',
    MAY: 'MAY',
    JUNE: 'JUNE',
    JULY: 'JULY',
    AUGUST: 'AUGUST',
    SEPTEMBER: 'SEPTEMBER',
    OCTOBER: 'OCTOBER',
    NOVEMBER: 'NOVEMBER',
    DECEMBER: 'DECEMBER'
};
/**
 * @export
 */
export const GetPlanDisplaysSubscriptionScheduleEnum = {
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
/**
 * @export
 */
export const GetPlanDisplaysPlanCurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    JPY: 'JPY',
    GBP: 'GBP',
    AUD: 'AUD',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    INR: 'INR',
    NZD: 'NZD'
};
/**
 * @export
 */
export const GetPlanDisplaysDesiresAddonPlanEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const GetPlanSupportAddonEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const GetStatisticsFractionFractionTypeEnum = {
    CURRENT_DOMAINS: 'CURRENT_DOMAINS',
    CURRENT_MEMBERS: 'CURRENT_MEMBERS',
    CURRENT_PHONE_NUMBERS: 'CURRENT_PHONE_NUMBERS',
    CURRENT_MAX_DAILY_BOUNCES: 'CURRENT_MAX_DAILY_BOUNCES',
    CURRENT_MAX_TOTAL_BOUNCES: 'CURRENT_MAX_TOTAL_BOUNCES',
    CURRENT_MAX_TOTAL_COMPLAINTS: 'CURRENT_MAX_TOTAL_COMPLAINTS',
    CURRENT_TOTAL_VERIFICATION_REQUESTS: 'CURRENT_TOTAL_VERIFICATION_REQUESTS',
    MONTHLY_INBOXES: 'MONTHLY_INBOXES',
    MONTHLY_RECEIVE: 'MONTHLY_RECEIVE',
    MONTHLY_SEND: 'MONTHLY_SEND',
    MONTHLY_VERIFICATION_REQUESTS: 'MONTHLY_VERIFICATION_REQUESTS'
};
/**
 * @export
 */
export const GetUsageRecordsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetUsageSummaryAddonEnum = {
    INBOXES: 'INBOXES',
    CONNECTORS: 'CONNECTORS',
    EMAILS: 'EMAILS',
    AI: 'AI',
    VALIDATION: 'VALIDATION',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const WaitForStripeWebhookEventTypeEnum = {
    customerDeleted: 'customerDeleted',
    setupIntentSucceeded: 'setupIntentSucceeded',
    paymentIntentSucceeded: 'paymentIntentSucceeded',
    invoicePaymentSucceeded: 'invoicePaymentSucceeded',
    invoicePaid: 'invoicePaid',
    invoiceVoided: 'invoiceVoided',
    invoiceUncollectible: 'invoiceUncollectible',
    customerSubscriptionCreated: 'customerSubscriptionCreated',
    customerSubscriptionDeleted: 'customerSubscriptionDeleted',
    customerSubscriptionUpdated: 'customerSubscriptionUpdated',
    chargeFailed: 'chargeFailed',
    paymentIntentPaymentFailed: 'paymentIntentPaymentFailed',
    invoicePaymentFailed: 'invoicePaymentFailed',
    radarEarlyFraudWarningCreated: 'radarEarlyFraudWarningCreated',
    chargePending: 'chargePending',
    chargeSucceeded: 'chargeSucceeded',
    chargeDisputed: 'chargeDisputed',
    quoteCreated: 'quoteCreated',
    quoteAccepted: 'quoteAccepted',
    quoteFinalized: 'quoteFinalized',
    quoteCanceled: 'quoteCanceled'
};
